// Module
var code = "<div> <div v-if=\"loading\" class=\"alignc\"> <loader></loader> </div> <component v-if=\"!loading && component != null\" :is=\"component\" :notification=\"notification\" data-id=\"notification\"></component> <div v-if=\"!loading && component == null\" data-id=\"notification-long\">{{ notification.LongText }}</div> </div> ";
// Exports
export default code;